import React, { useEffect, useState } from 'react';
import { API } from '../../api/Api';
import { useNavigate } from 'react-router-dom';
import { BeatLoader, ClipLoader } from "react-spinners";
import { toast, Toaster } from 'react-hot-toast';
import kitchen from '../../assets/KV_img3.jpg'



const LoginCard = () => {
    const [userEmail, setUserEmail] = useState('');
    const [userPass, setUserPass] = useState('');
    const [emailError, setEmailError] = useState('');
    const [passowrdError, setPassowrdError] = useState('');
    const [loading, setLoading] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
    const navigate = useNavigate()

    useEffect(() => {
    }, [])



    const validateEmail = (email) => {
        if (email === "") {
            setEmailError('Email is Required.');
            return false;
        }
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isValid = emailPattern.test(email);
        setEmailError(isValid ? '' : 'Please enter a valid email address.');
        return isValid;
    };

    const validatePass = (password) => {
        if (password === "") {
            setPassowrdError('password is Required.');
            return false;
        } else if (password !== '') {
            setPassowrdError('');
            return true;
        }
    };
    const handleEmailChange = (e) => {
        const email = e.target.value;
        setUserEmail(email);
        validateEmail(email);
    };

    const handlePassChange = (e) => {
        const password = e.target.value;
        setUserPass(password);
        validatePass(password);
    };

    const handleLogin = async (e) => {

        e.preventDefault();
        if (!validateEmail(userEmail) || !validatePass(userPass)) {
            return;
        }

        const baseURl = process.env.REACT_APP_API_URL;
        const apiPath = '/login/login';
        const Passwordurl = `${baseURl}${apiPath}`;
        const passwordBody = {
            email: userEmail,
            password: userPass,
            remember_me: "1"
        };
        try {
            setLoading(true)
            const response = await API(Passwordurl, passwordBody);

            if (response && response.Result_value.token) {

                if (rememberMe) {
                    localStorage.setItem('token', response.Result_value.token);
                    // navigate('/home');
                }
                else {
                    localStorage.setItem('token', response.Result_value.token);
                }

                toast.success("Welcome ");
                navigate('/admin/layouts');
            }

            else {
                // setNotificationMessage('Wrong email or password!');
                // setColor('red')
                // setNotificationVisible(true);
                // setTimeout(() => {
                //     setNotificationVisible(false);
                // }, 2000);
                toast.error('Wrong Password.');
                <div class="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 rounded-lg">
                    <p class="text-lg font-semibold">wrong password</p>
                </div>
            }
            setLoading(false)
        } catch (error) {
            console.error('Error during authentication:', error);
            setLoading(false)
            return false;
        }

    }


    return (
        <>
            {/* Full-screen loader */}
            {loading && (
                <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/30">
                    <BeatLoader
                        color="red"
                        loading={true}
                        size={50}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                </div>
            )}
            <Toaster position="top-center" />
            <div
                className="min-h-screen flex items-center justify-center p-4"
                style={{
                    backgroundImage: `url(${kitchen})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundAttachment: 'fixed',
                    backdropFilter: 'blur(8px)',
                }}
            >
                <div className="w-full border-white max-w-sm p-8 rounded-2xl shadow-lg bg-gradient-to-br from-slate-900 to-blue-900 text-gray-200">
                    {/* Logo */}
                    <div className="flex justify-center mb-6">
                        <div className="">
                            <img src="https://www.domaincabinets.com/v/vspfiles/templates/260/images/template/header_bg.png" alt="" />
                        </div>
                    </div>

                    {/* Title */}
                    <h2 className="text-2xl font-bold text-center mb-6 text-green-400">LOG IN</h2>

                    {/* Form */}
                    <div className="space-y-4">
                        {/* Username Input */}
                        <div className="flex items-center border-b border-gray-500 py-2">
                            <svg className="w-5 h-5 mr-3 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                            </svg>
                            <input
                                type="email"
                                value={userEmail}
                                onChange={handleEmailChange}
                                placeholder="Your email address"
                                className="w-full bg-transparent outline-none placeholder-gray-400"
                            />
                        </div>
                        {emailError && <p className="text-red-400 text-sm ">{emailError}</p>}

                        {/* Password Input */}
                        <div className="flex items-center border-b border-gray-500 py-2">
                            <svg className="w-5 h-5 mr-3 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 11c0-1.1-.9-2-2-2s-2 .9-2 2v2H6v-2a4 4 0 018 0v2h-2v-2zm-2 6a2 2 0 100-4 2 2 0 000 4zm0 0v2m0-6v-2"></path>
                            </svg>
                            <input
                                type="password"
                                value={userPass}
                                onChange={handlePassChange}
                                placeholder='Your password'
                                className="w-full bg-transparent outline-none placeholder-gray-400"
                            />
                            {passowrdError && <p className="text-red-400 text-sm mt-2">{passowrdError}</p>}
                        </div>

                        {/* Remember Me Checkbox */}
                        {/* <div className="flex items-center">
                            <input
                                type="checkbox"
                                id="remember"
                                className="w-4 h-4 mr-2 bg-transparent border-gray-500 text-green-400 focus:ring-0"
                            />
                            <label htmlFor="remember" className="text-sm">Remember me</label>
                        </div> */}

                        {/* Log In Button */}
                        <button onClick={handleLogin} className="w-full bg-green-500 text-gray-900 font-semibold py-2 rounded-full hover:bg-green-600 transition">
                            LOG IN
                        </button>

                        {/* Forgot Password Link */}
                        {/* <div className="text-center">
                        <a href="#" className="text-sm text-green-400 hover:underline">Forgot Password?</a>
                    </div> */}
                    </div>
                </div>
            </div>
        </>
    );
};

export default LoginCard;